import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TabList, Toolbar, ToolbarGroup } from "@fluentui/react-components";
import { NavBarItems } from "./nav-models";
import { Logo } from "../Logo";
import { TooltipTab } from "../TooltipTab";
import { CollapsedNavMenu } from "./NavMenu";
import { usePython } from "../../hooks/usePython";
import "./TopBar.scss";
import Env from "xlcommon/src/environ";

export const TopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPython } = usePython();

  const selectedValue: string = "/" + location.pathname.split("/")[1];

  const [title, setTitle] = useState<string>("Anaconda Toolbox");
  useEffect(() => {
    if (location.pathname.length > 0) {
      if (selectedValue === "/") {
        setTitle("Anaconda Toolbox");
      } else {
        // Find matching NavMenuItem
        for (const item of NavBarItems) {
          if (item.path === selectedValue) {
            setTitle(item.title);
            break;
          }
        }
      }
    }
  }, [location.pathname]);

  return (
    <Toolbar className="toolbar" aria-label="tab bar">
      <ToolbarGroup>
        <Logo title={title} />
      </ToolbarGroup>
      <ToolbarGroup
        style={{
          display: "flex",
          gap: 0,
          marginRight: Office.context.platform === Office.PlatformType.PC ? "14px" : "20px",
        }}
      >
        <TabList
          className="tab-list"
          selectedValue={selectedValue}
          appearance="subtle"
          // Tab value must match route path
          onTabSelect={(_, data) => navigate(data.value)}
        >
          {NavBarItems.map((item) => {
            const disabled = item.disabled || (item.requiresPython && !hasPython && !Env.UNLOCKED);
            const tabClasses = ["tab"];
            if (selectedValue === item.path) tabClasses.push("active");
            if (disabled) tabClasses.push("disabled");
            if (item.priority) tabClasses.push("priority");
            return (
              <TooltipTab
                key={item.title}
                tooltipContent={item.title}
                icon={<item.Icon />}
                value={item.path}
                disabled={disabled}
                className={tabClasses.join(" ")}
              >
                {item.title}
              </TooltipTab>
            );
          })}
        </TabList>
        <CollapsedNavMenu />
      </ToolbarGroup>
    </Toolbar>
  );
};

export default TopBar;
